import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import '@components/mixins/commonStyles.scss';
import style from './EditEntryData.module.scss';

import { EntryData } from 'chaika-frontend-types/frontend-cms/entry';

import { translate } from '@chaika/i18n/helper';
import { SelectionButtons } from '@components/SelectionButtons';
import { useSelectionButtons } from './hooks/useSelectionButtons';
import { EditEntryDataForm } from './EditEntryDataForm';

interface Props {
    entry: EntryData;
}

export const EditEntryData = observer(({ entry }: Props): React.ReactElement<any> => {
    const { activeTab, tabItems, setTab } = useSelectionButtons();

    return (
        <div className={style.root}>
            <div className={classNames(['font_h2', style.title])}>{translate('changeEntryData')}</div>
            <SelectionButtons
                selectedValue={activeTab}
                values={tabItems}
                onSelect={setTab}
            />
            <EditEntryDataForm
                entry={entry}
                tab={activeTab}
            />
        </div>
    );
});
